import { faBadgeCheck } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Style } from 'inlines'

export const Badge = ({ style }: { style?: Style }) => {
  return (
    <FontAwesomeIcon
      icon={faBadgeCheck}
      color="var(--primary-red)"
      style={{
        height: '1rem',
        width: '1rem',
        ...style,
      }}
    />
  )
}
